import { useLayoutEffect, useRef } from 'react';

import { use$ } from '@legendapp/state/react';

import { DeviceType, containerStore, deviceSettingStore } from '../../../store';

const useContainerPosition = () => {
	const observer = useRef<IntersectionObserver | null>(null);
	const wasIntersecting = useRef(false);

	const container = use$(containerStore.container) as HTMLElement;
	const isContainerReady = use$(containerStore.isContainerReady);
	const nbaHeight = use$(containerStore.nbaHeight);

	const deviceType = use$(deviceSettingStore.deviceType);

	const isIphone = deviceType === DeviceType.iPhone;

	function handlePositionChange(auto?: boolean) {
		if (!container) return;

		const { bottom } = container.getBoundingClientRect();

		const isPortrait = window.screen.orientation?.type?.includes('portrait') ?? false;
		const viewportHeight = window.visualViewport?.height || window.innerHeight;
		const { scrollY } = window;

		const iPhoneOffset = isIphone && isPortrait && auto ? 10 : 0;
		const targetScroll = scrollY + bottom - viewportHeight + nbaHeight + iPhoneOffset;

		window.scrollTo({
			top: targetScroll,
			behavior: auto ? 'auto' : 'smooth'
		});
	}

	useLayoutEffect(() => {
		if (!container || !isContainerReady) return;

		function handleOrientationChange() {
			if (isIphone) return handlePositionChange(true);
			setTimeout(() => handlePositionChange(true), 100);
		}

		function handleVisualiserScrollPosition(entries: IntersectionObserverEntry[]) {
			entries.forEach(({ isIntersecting }) => {
				wasIntersecting.current = isIntersecting;
			});
		}

		window.addEventListener('orientationchange', handleOrientationChange);

		observer.current = new IntersectionObserver(handleVisualiserScrollPosition, {
			threshold: 0.6,
			rootMargin: '0px'
		});

		observer.current?.observe(container);

		return () => {
			observer.current?.unobserve(container);
			window.removeEventListener('orientationchange', handleOrientationChange);
		};
	}, []);

	return { handlePositionChange };
};

export default useContainerPosition;
